<cxone-modal #modal class="cxone-modal" [ngClass]="{'invalid-form': !isValidForm()}" [headerTitle]="headerTitle" [allowClose]="allowClose" cancelLabel="cancelLabel"
    [saveLabel]="saveLabel" (dismissed)="onDismiss()" (closed)="save()" [customFooter]="true">
    <cxone-challenge-create #createForm></cxone-challenge-create>
    <cxone-modal-footer>
        <div class="d-flex justify-content-end buttons-container">
            <sol-button variant="basic" (onClick)="modal.dismiss()">{{cancelLabel}}</sol-button>
            <sol-button variant="primary" class="save-button" (onClick)="save()" [disabled]="!isValidForm()">{{saveLabel}}</sol-button>
        </div>
    </cxone-modal-footer>
</cxone-modal>